import { render, staticRenderFns } from "./UiButtonNew.vue?vue&type=template&id=4fc29698&"
import script from "./UiButtonNew.vue?vue&type=script&lang=js&"
export * from "./UiButtonNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports